import { combineReducers } from 'redux';
import { Reducer as experiments } from '@nerdwallet/nw-client-lib/ab';
import { reducer as impressions } from '@nerdwallet/nw-client-lib/tracking';

import pressArticles from './reducers/press-articles';
import specialistsData from './reducers/specialists';
import featureFlags from './reducers/feature-flags';

import * as Actions from './actions';

const errors = (state = [], action) => {
  switch (action.type) {
    case Actions.REQUEST_ERROR:
      return [...state, action.error];
    default:
      return state;
  }
};

function createReducer(additionalReducers = {}) {
  return combineReducers({
    pressArticles,
    specialistsData,
    errors,
    experiments,
    featureFlags,
    impressions,
    ...additionalReducers,
  });
}

const combinedReducers = createReducer();

export default function rootReducer(state = {}, action) {
  return combinedReducers(state, action);
}
